import Vue from 'vue';
import Galleria from 'primevue/galleria';

Vue.component('Galleria', Galleria);
